"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _entity = require('shared/enum/entity');
























const isPatientEntity = (entity) =>
  entity.type === _entity.ENTITY_TYPES.PATIENT

const isUserEntity = (entity) =>
  entity.type === _entity.ENTITY_TYPES.USER

 const deriveSender = ({
  recipients,
  myPhoneTeams,
  myActiveOrgKeys,
  manualSender,
}) => {
  if (manualSender) return { type: 'manual' }

  const patient = recipients.find(isPatientEntity)
  if (patient) {
    const orgKey = patient.wrappedEntity.OrgKey
    if (!myActiveOrgKeys.includes(orgKey)) return { type: 'default' }

    const candidateTeamKeys = myPhoneTeams
      .filter(team => team.OrgKey === orgKey)
      .map(team => team.TeamKey)

    if (candidateTeamKeys.length === 1) {
      return { type: 'derived', senderKey: candidateTeamKeys[0] }
    }
    if (candidateTeamKeys.length > 1) {
      return { type: 'ambiguous', candidateTeamKeys, orgKey }
    }
    return { type: 'derived', senderKey: orgKey }
  }

  if (!recipients.length || !recipients.every(isUserEntity)) {
    return { type: 'default' }
  }

  const mutualOrgKeys = myActiveOrgKeys.filter(orgKey =>
    recipients.every(recipient => {
      const relationship = _optionalChain([recipient, 'access', _ => _.wrappedEntity, 'access', _2 => _2.Relationships, 'optionalAccess', _3 => _3[orgKey]])
      return relationship && !relationship.Pending
    }),
  )

  return mutualOrgKeys.length === 1
    ? { type: 'derived', senderKey: mutualOrgKeys[0] }
    : { type: 'default' }
}; exports.deriveSender = deriveSender

 const derivePinnedOrgKey = (
  recipients,
  manualSender,
) => {
  const patient = recipients.find(isPatientEntity)
  return _nullishCoalesce(_nullishCoalesce(_optionalChain([patient, 'optionalAccess', _4 => _4.wrappedEntity, 'access', _5 => _5.OrgKey]), () => ( _optionalChain([manualSender, 'optionalAccess', _6 => _6.orgKey]))), () => ( null))
}; exports.derivePinnedOrgKey = derivePinnedOrgKey
